import * as APITypes from "../API";
import * as CustomAPITypes from "./customAPI";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const customListProjectsBasicInfoByAccount = /* GraphQL */ `query CustomListProjectsByAccount(
  $projectAccountId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listProjectsByAccount(
    projectAccountId: $projectAccountId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectAccountId
      title
      createdAt
      description
      thumbS3Url
      isDeleted
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
  APITypes.ListProjectsByAccountQueryVariables,
  CustomAPITypes.CustomListProjectsBasicInfoByAccountQuery
>;

export const customGetUser = /* GraphQL */ `
  query CustomGetUser(
    $id: ID!
    $accountsLimit: Int
    $accountsNextToken: String
  ) {
    getUser(id: $id) {
      id
      email
      name
      lastName
      picture
      createdAt
      updatedAt
      accounts(limit: $accountsLimit, nextToken: $accountsNextToken) {
        items {
          id
          accountId
          userId
          createdAt
          updatedAt
          permissions
          workType
          roleInCompany
          account {
            id
            name
            aliasId
            minisiteDomain
            mfaEnabled
            tierId
            createdAt
            updatedAt
            stripeCustomerId
            companySize
            accountUsageType
            fonts {
              fontFamily
              variants {
                name
                weight
                style
                url
              }
            }
            fileuploads {
              originalName
              createdAt
              fileName
              fileStatus
              fileError
              numRecords
              numErrors
              totalRecords
              writtenRecords
            }
            createNewVideosWithBlingLogo
            accountType {
              levelName
              permissions {
                removeBlingLogo
                aiOptimization
              }
            }
          }
        }
        nextToken
      }
    }
  }
` as GeneratedQuery<
  CustomAPITypes.CustomGetUserQueryVariables,
  CustomAPITypes.CustomGetUserQuery
>;

export const customGetProject = /* GraphQL */ `query CustomGetProject($id: ID!) {
  getProject(id: $id) {
    id
    projectAccountId
    title
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      createdAt
      updatedAt
      __typename
    }
    videoParts {
      name
      jsonUrl
      mods
      updatedAt
      hasVideo
      origin
      playerVersionToUse
      description
      __typename
    }
    allowCreateDataPoint
    allowDataConnect
    allowCrmConnect
    allowSdkConnect
    allowSendFormData
    analyticsReportUrl
    createdAt
    dataFiles {
      fileName
      tag
      createdAt
      __typename
    }
    description
    fileName
    jsonChanges
    jsonVidUrl
    playerSettings {
      autoplay
      autoplay_delay
      posterFrame
      showTimeline
      storiesMode
      color_loader
      color_ctrlBtns
      color_rail
      color_progress
      color_thumb
      color_bg
      muted
      autoReplay
      showBlingsLogo
      blingsLogoColor
      loadingText
      loadingImage
      __typename
    }
    projectVersions {
      nextToken
      __typename
    }
    settings
    stateJsonSchemaStr
    settingsJsonSchemaStr
    thumbS3Url
    experiments {
      id
      type
      __typename
    }
    experimentOptimizationTechnique
    analyticsEnabled
    owner
    aliasId
    minisiteConfigs {
      scenes
      title
      description
      thumbUrl
      faviconUrl
      preCreate
      __typename
    }
    playerVersionToUse
    customHtml
    dynamicThumbnails {
      name
      id
      createdAt
      updatedAt
      __typename
    }
    publishedAt
    allowedOrigins
    flowDiagram {
      nodes {
        id
        label
        type
        data
        lineupId
      }
      edges {
        source
        target
        sourceHandle
        index
      }
      __typename
    }
    textToVideoScript
    instantiatedFromUseCase
    overlay {
      audio {
        url
        volume
        loop
      }
      __typename
    }
    fontOverrides {
      family
      url
      weight
      style
      __typename
    }
    isDeleted
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectQueryVariables,
  APITypes.GetProjectQuery
>;
